import customaxios from ".";

export const submitEnquiry = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: "/enquiry/submit",
    data,
  });
};

export const getFaqs = () => {
  return customaxios({
    method: 'GET',
    url: '/enquiry/faq',
  })
}

export const generateGoogleMapsDirectionsUrl = (
  originLat: number,
  originLng: number,
  destinationLat: number,
  destinationLng: number
): string => {
  return `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destinationLat},${destinationLng}&travelmode=driving`;
};
